import type { PowerBiWorkspaceReport, ReportCatalogItem } from './types';

/** "Collections Overview (Weekly)" → "collections-overview-weekly" */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Turn a workspace listing into catalog entries, sorted by name so the menu is
 * stable regardless of the API's order. Slugs come from the report name; a
 * repeated slug gets a numeric suffix so every report keeps its own page
 * instead of shadowing an earlier one. A name that slugifies to nothing
 * (symbols only) falls back to the report ID.
 */
export function buildReportsCatalog(
  reports: PowerBiWorkspaceReport[],
  groupId: string
): ReportCatalogItem[] {
  const sorted = [...reports].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
  );

  const seen = new Map<string, number>();
  return sorted.map(report => {
    const base = slugify(report.name) || report.id;
    const count = (seen.get(base) ?? 0) + 1;
    seen.set(base, count);
    return {
      slug: count === 1 ? base : `${base}-${count}`,
      name: report.name,
      groupId,
      reportId: report.id,
    };
  });
}
